@if (isShowLoader) {
  <div class="loader">
    <div class="loader__overlay">
      <mat-spinner diameter="77" mode="indeterminate"></mat-spinner>
      <h3>{{text}}</h3>
    </div>
  </div>
}
